module.exports = __webpack_public_path__ + "static/assets/1f7b123ef7b9366e240cc9c533556fc1.png";